import React, { useContext, useEffect, useState } from 'react';
import instance from '../Config/AxiosConfig';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { AuthContext } from '../Context/AuthProvider';

function AddPublications({ handlePublicationModalClose, showPublicationModal, setCreatePub }) {
    const [type, setType] = useState([]);
    const userId = Cookies.get('userId');
    useEffect(() => {
        const token = Cookies.get('token');
        instance.get("/articles/getAllTypes", {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(response => {
                setType(response.data);
            })
            .catch(error => {
                console.error('Erreur lors de la récupération des données:', error);
            });
    }, []);

    const [formData, setFormData] = useState({
        title: '',
        documentType: '',
        file: null, // Update to handle file object
        date: '',
        doi: '',
    });

    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState('');
    const history = useHistory()
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'file') {
            // Handle file input separately
            setFormData(prevState => ({
                ...prevState,
                file: e.target.files[0] // Save the file object
            }));
        } else {
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const validateForm = () => {
        const errors = {};
        if (!formData.title) errors.title = 'article name is required';
        if (!formData.documentType) errors.documentType = 'article type is required';
        if (!formData.date) errors.date = 'date is required';
        if (!formData.file) errors.file = 'file is required'; // Add file validation

        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const token = Cookies.get('token');
        const data = new FormData();
        data.append('title', formData.title);
        data.append('documentType', formData.documentType);
        data.append('date', formData.date);
        data.append('doi', formData.doi);
        data.append('file', formData.file); // Append the file

        try {
            const response = await instance.post('/articles/add', data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.status === 200) {
                Swal.fire({
                    text: "Article added successfully!",
                    icon: "success"
                });
                if (showPublicationModal) {
                    handlePublicationModalClose();
                }

                if (window.location.pathname == '/createPublication') {
                    history.push(`/myprofil/${userId}`);
                }
                setFormData({ title: '', documentType: '', date: '', doi: '', file: null });
                setCreatePub(response.data);
                setErrors({});




            } else {
                Swal.fire({
                    title: "Error!",
                    text: "Failed to add article.",
                    icon: "error"
                });
                console.error('response status:', response.status);
                setErrors({ form: 'Failed to add project. Error from server.' });
            }
        } catch (error) {
            console.error('Error adding project:', error);
        }
    };

    return (
        <>
            {errors.form && <p style={{ color: 'red' }}>{errors.form}</p>}
            {success && <p style={{ color: 'green' }}>{success}</p>}
            <form className="row g-3" onSubmit={handleSubmit}>
                <div className="col-12">
                    <label className="form-label">Publication Title</label>
                    <input type="text"
                        className="form-control"
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                        placeholder="publication title (Required)" />
                    {errors.title && <small style={{ color: 'red' }}>{errors.title}</small>}
                </div>

                <div className="col-12">
                    <label className="form-label">Publication Type</label>
                    <select
                        className="form-select js-choice"
                        name="documentType" onChange={handleChange}
                        value={formData.documentType}
                    >
                        <option value="">Select type</option>
                        {type.map((c, i) => (
                            <option key={i} value={c.id}>{c.type}</option>
                        ))}
                    </select>
                    {errors.documentType && <small style={{ color: 'red' }}>{errors.documentType}</small>}
                </div>

                <div className="col-12">
                    <label className="form-label">DOI</label>
                    <input type="text"
                        className="form-control"
                        name="doi"
                        value={formData.doi}
                        onChange={handleChange}
                        placeholder="publication DOI" />
                    {errors.doi && <small style={{ color: 'red' }}>{errors.doi}</small>}
                </div>

                <div className="col-12 mb-3">
                    <label className="form-label">Upload File</label>
                    <div className="dropzone dropzone-default card shadow-none d-flex justify-content-center align-items-center">
                        <div className="dz-message text-center">
                            <img src="assets/images/docIa.png" style={{ width: 280, height: 'auto' }} alt="Upload" />
                            <input onChange={handleChange} className="form-control" type="file" name="file" id="formFile" />
                        </div>
                    </div>
                    {errors.file && <small style={{ color: 'red' }}>{errors.file}</small>}
                </div>

                <div className="col-sm-6 col-12">
                    <label className="form-label">Date</label>
                    <input type="date"
                        className="form-control"
                        name="date"
                        value={formData.date}
                        onChange={handleChange}
                        placeholder="JJ/MM/AAAA" />
                    {errors.date && <small style={{ color: 'red' }}>{errors.date}</small>}
                </div>

                <div className="col-12 text-end">
                    <button type="submit" className="btn btn-primary mb-0">Save</button>
                </div>
            </form>
        </>
    );
}

export default AddPublications;
